import { reads } from "@ember/object/computed";
import { classNames } from "@ember-decorators/component";
import icon from "discourse/helpers/d-icon";
import discourseComputed from "discourse/lib/decorators";
import ComboBoxSelectBoxHeaderComponent from "select-kit/components/combo-box/combo-box-header";
import { resolveComponent } from "select-kit/components/select-kit";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const CategoryDropHeader = dt7948.c(class CategoryDropHeader extends ComboBoxSelectBoxHeaderComponent {
  static {
    dt7948.g(this.prototype, "shouldDisplayIcon", [reads("selectKit.options.shouldDisplayIcon")]);
  }
  #shouldDisplayIcon = (dt7948.i(this, "shouldDisplayIcon"), void 0);
  categoryBackgroundColor(categoryColor) {
    return categoryColor || "#e9e9e9";
  }
  static {
    dt7948.n(this.prototype, "categoryBackgroundColor", [discourseComputed("selectedContent.color")]);
  }
  categoryTextColor(categoryTextColor) {
    return categoryTextColor || "#333";
  }
  static {
    dt7948.n(this.prototype, "categoryTextColor", [discourseComputed("selectedContent.text_color")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <div class=\"select-kit-header-wrapper\">\n      {{#let (resolveComponent this this.selectKit.options.selectedNameComponent) as |SelectedNameComponent|}}\n        <SelectedNameComponent @tabindex={{this.tabindex}} @item={{this.selectedContent}} @selectKit={{this.selectKit}} @shouldDisplayIcon={{this.shouldDisplayIcon}} @shouldDisplayClearableButton={{this.shouldDisplayClearableButton}} />\n      {{/let}}\n\n      {{icon this.caretIcon class=\"caret-icon\"}}\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        resolveComponent,
        icon
      })
    }), this);
  }
}, [classNames("category-drop-header")]);
export default CategoryDropHeader;